<template>
    <v-layout wrap>
        <v-flex class="mb-4 d-flex align-items-center">
            <div>
                <h1 class="d-inline-block vertical-align-middle">{{ $t('id_POST_ISSUE_LOG-details') }}</h1>
            </div>
        </v-flex>
        <!-- Add/Edit  ID_POST_ISSUE_LOG -->
        <v-form class="flex xs12 mb-3" @submit.prevent="saveID_POST_ISSUE_LOG">
            <v-card>
                <v-container grid-list-lg>
                    <v-layout wrap>

                        <v-flex md4 sm6 xs12>
                            <v-text-field class="mr-2"
                                          :label="$t('NAT_NO')"
                                          v-model="id_POST_ISSUE_LOG.natno"
                                          v-validate="'max:2000'"
                                          :data-vv-as="$t('NAT_NO')"
                                          readonly
                                          :error-messages="errors.collect('NAT_NO')"
                                          name="NAT_NO"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field class="mr-2"
                                          :label="$t('full-name')"
                                          v-model="id_POST_ISSUE_LOG.full_name1"
                                          v-validate="'max:2000'"
                                          :data-vv-as="$t('full-name')"
                                          readonly
                                          :error-messages="errors.collect('full-name')"
                                          name="full_name1"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field class="mr-2"
                                          :label="$t('GUARDIAN_NAT_NO')"
                                          v-model="id_POST_ISSUE_LOG.guardiannatno"
                                          v-validate="'max:2000'"
                                          readonly
                                          :data-vv-as="$t('GUARDIAN_NAT_NO')"
                                          :error-messages="errors.collect('guardian_nat_no')"
                                          name="guardian_nat_no"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field class="mr-2"
                                          :label="$t('full-name')"
                                          v-model="id_POST_ISSUE_LOG.full_name2"
                                          v-validate="'max:2000'"
                                          :data-vv-as="$t('full-name')"
                                          readonly
                                          :error-messages="errors.collect('full-name')"
                                          name="full_name2"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field class="mr-2"
                                          :label="$t('WORKSTATION')"
                                          v-model="id_POST_ISSUE_LOG.workstation"
                                          v-validate="'max:2000'"
                                          readonly
                                          :data-vv-as="$t('WORKSTATION')"
                                          :error-messages="errors.collect('workstation')"
                                          name="workstation"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field class="mr-2"
                                          :label="$t('OPERATOR_NAT_NO')"
                                          v-model="id_POST_ISSUE_LOG.operatornatno"
                                          v-validate="'max:2000'"
                                          readonly
                                          :data-vv-as="$t('OPERATOR_NAT_NO')"
                                          :error-messages="errors.collect('operator_nat_no')"
                                          name="operator_nat_no"></v-text-field>
                        </v-flex>
                          
                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('UPDATE_TYPE')"
                                          class="mr-2"
                                          readonly
                                          v-model="id_POST_ISSUE_LOG.updatetype"
                                          v-validate="'max:14'"
                                          :data-vv-as="$t('UPDATE_TYPE')"
                                          :error-messages="errors.collect('update_type')"
                                          name="update_type"></v-text-field>
                        </v-flex>

                        <!--<v-flex md4 sm6 xs12>
        <v-text-field :label="$t('COLUMN1')"
                      class="mr-2"
                      v-model="id_POST_ISSUE_LOG.column1"
                      v-validate="'max:15'"
                      :data-vv-as="$t('COLUMN1')"
                      :error-messages="errors.collect('column1')"
                      name="column1"></v-text-field>
    </v-flex>-->
                        <!--<v-flex md4 sm6 xs12>
        <v-text-field :label="$t('ISSUEDATE')"
                      class="mr-2"
                      readonly
                      v-model="id_POST_ISSUE_LOG.issuedate"
                      v-validate="'max:15'"
                      :data-vv-as="$t('ISSUEDATE')"
                      :error-messages="errors.collect('issuedate')"
                      name="issuedate"></v-text-field>
    </v-flex>-->

                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('EXPIRY_DATE')"
                                          class="mr-2"
                                          readonly
                                          v-model="id_POST_ISSUE_LOG.expirydate"
                                          v-validate="'max:15'"
                                          :data-vv-as="$t('EXPIRY_DATE')"
                                          :error-messages="errors.collect('expiry_date')"
                                          name="expiry_date"></v-text-field>
                        </v-flex>

                        <v-flex md4 sm6 xs12>
                            <v-text-field :label="$t('UPDATE_DATE')"
                                          class="mr-2"
                                          readonly
                                          v-model="id_POST_ISSUE_LOG.updatedate"
                                          v-validate="'max:15'"
                                          :data-vv-as="$t('EXPIRY_DATE')"
                                          :error-messages="errors.collect('UPDATE_DATE')"
                                          name="updatedate"></v-text-field>
                        </v-flex>

                        <!--<v-flex md4 sm6 xs12>
        <v-switch v-model="translatorDefinition.isCertificatePracticing" :label="$t('isCertificatePracticing')"></v-switch>
    </v-flex>-->
                    </v-layout>
                    <!--<v-btn color="primary" type="submit">{{ $t('save') }}</v-btn>-->
                    <v-btn color="primary" :to="{ name: 'HCD' }">{{ $t('cancel') }}</v-btn>
                </v-container>
            </v-card>
        </v-form>
    </v-layout>
</template>

<script>
    import ID_POST_ISSUE_LOGService from '@/services/Disabilities/PersonWithDisabilities/ID_POST_ISSUE_LOG/ID_POST_ISSUE_LOGService';
    import BeneficiaryInformationManagementService from '@/services/Disabilities/PersonWithDisabilities/BeneficiaryInformationManagement/BeneficiaryInformationManagement/BeneficiaryInformationManagementService';

    export default {
        name: 'id_POST_ISSUE_LOG-details',
        data() {
            return {
                selected: [],
                // Filters
                id_POST_ISSUE_LOG: {
                    id: 0,
                    nat_no: null,
                    update_type: null,
                    guardian_nat_no: null,
                    workstation: null,
                    operator_nat_no: null,
                    column1: null,
                    issuedate: null,
                    expiry_date: null,
                    update_date: '',
                    full_name1: '',
                    full_name2: '',
                    full_name3: '',
                },  
            };
        },

        async created() {
            /* to call the  Entities(drop down lists)  which are used in this Entity */

            const id_POST_ISSUE_LOGId = this.$route.params.id;
            if (id_POST_ISSUE_LOGId) {
                /* add loading in edit mode */
                this.$store.dispatch('showLoading');
                const id_POST_ISSUE_LOG = (await ID_POST_ISSUE_LOGService.getID_POST_ISSUE_LOG(id_POST_ISSUE_LOGId)).data;

                if (id_POST_ISSUE_LOG.updatedate) {
                    id_POST_ISSUE_LOG.updatedate = id_POST_ISSUE_LOG.updatedate.substr(0, 10);
                }

                if (id_POST_ISSUE_LOG.expirydate) {
                    id_POST_ISSUE_LOG.expirydate = id_POST_ISSUE_LOG.expirydate.substr(0, 10);
                }

                if (id_POST_ISSUE_LOG.issuedate) {
                    id_POST_ISSUE_LOG.issuedate = id_POST_ISSUE_LOG.issuedate.substr(0, 10);
                }

                this.$store.dispatch('hideLoading');
                if (!id_POST_ISSUE_LOG) this.$router.push({ name: 'id_POST_ISSUE_LOG-list' });
                this.id_POST_ISSUE_LOG = { ...this.id_POST_ISSUE_LOG, ...id_POST_ISSUE_LOG };
                this.GetCSPDNameBYNationalNum1();
            }
        },

        methods: {
            async GetCSPDNameBYNationalNum1( ) { 
                const result = await BeneficiaryInformationManagementService.GetCSPDNameBYNationalNum(this.id_POST_ISSUE_LOG.natno);
                this.id_POST_ISSUE_LOG.full_name1 = result.data;
                const result2 = await BeneficiaryInformationManagementService.GetCSPDNameBYNationalNum(this.id_POST_ISSUE_LOG.guardiannatno);
                this.id_POST_ISSUE_LOG.full_name2 = result2.data; 
            },
            /* save Operation */
            async saveID_POST_ISSUE_LOG() {
                const isValid = await this.$validator.validateAll();
                if (isValid) {
                    /* add loading on save */
                    this.$store.dispatch('showLoading');
                    const result = await ID_POST_ISSUE_LOGService.saveID_POST_ISSUE_LOG(this.id_POST_ISSUE_LOG);
                    if (result.data.statusCode === 200) {
                        this.$store.dispatch('showMessage', { text: result.data.message });
                        this.$router.push({ name: 'id_POST_ISSUE_LOG-list' });
                    } else {
                        this.$store.dispatch('showMessage', { text: result.data.message, color: 'error' });
                        this.$router.push({ name: 'id_POST_ISSUE_LOG-list', color: 'error' });
                    }
                    this.$store.dispatch('hideLoading');
                }
            },

            /* Get Operations */

        }
    };
</script>
